function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, `8D0599D9-3631-4476-A3BF-3CE78EAB0B59`);

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, `Created with sketchtool.`);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "Influencers_Post_Approval",
  transform: "translate(-785.000000, -57.000000)",
  stroke: "#5B6572"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(774.000000, 46.000000)"
}, React.createElement("g", {
  id: "White_Envelope",
  transform: "translate(12.000000, 12.000000)"
}, React.createElement("path", {
  d: "M15.5130435,10.9217391 L0.347826087,10.9217391 C0.139130435,10.9217391 -9.09370767e-13,10.7826087 -9.09370767e-13,10.573913 L2,0.347826087 C2,0.139130435 2.13913043,0 2.34782609,0 L17.5130435,0 C17.7217391,0 17.8608696,0.139130435 17.8608696,0.347826087 L15.8608696,10.6086957 C15.8608696,10.7826087 15.6869565,10.9217391 15.5130435,10.9217391 Z",
  id: "Shape",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M2.24347826,0.417391304 L8.72173913,5.70434783 C8.82608696,5.77391304 9,5.77391304 9.10434783,5.70434783 L17.5826087,0.417391304",
  id: "Shape"
})))));

const SvgComponent = props => React.createElement("svg", _extends({
  width: "20px",
  height: "13px",
  viewBox: "0 0 20 13",
  version: 1.1,
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/icon-email.0e89ce9e.svg";
export { SvgComponent as ReactComponent };